<div class="homeBody">
    <img [src]="imgSrc" alt="Gesvatec logo" style="max-width: 250px;" />
</div>
